import DialogBox from "./dialog-box";

export default function ConfirmModal({
  show,
  title = "Confirm",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) {
  return (
    <DialogBox show={show}>
      <div className="bottom-0 bg-primary-white flex flex-col gap-6 relative w-full lg:w-pop-up lg:max-w-md p-8 rounded-t-lg lg:rounded-lg">
        <h4 className="text-h4 text-tertiary-dark font-bold">{title}</h4>
        <p className="text-secondary-dark text-p1">{message}</p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-6 h-[48px] border border-solid border-primary-dark-20 text-primary-dark text-h5 font-semibold hover:bg-neutral-10"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="px-6 h-[48px] bg-primary-dark text-primary-white text-h5 font-semibold hover:opacity-90"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </DialogBox>
  );
}
